export enum SubmitOrderLogColId {
  COMPANY = 'companyName',
  CREATED_AT = 'createdAt',
  DURATION = 'durationMs',
  ERROR = 'errorMessage',
  ERROR_DESCRIPTION = 'errorDescription',
  EXTERNAL_ORDER_NUMBER = 'externalOrderNumber',
  HTTP_STATUS = 'responseStatus',
  ORDER_ID = 'orderId',
  OUTCOME = 'outcome',
  PAYLOAD = 'payload',
  SIZE = 'requestBodyBytes',
  USER = 'userName',
}
